import assets from 'shared/assets';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: url(${assets.bg}) no-repeat center center;
  background-size: cover;
`;

const WrapperBinder = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  font-family: proxima-nova, sans-serif;
  *{
    box-sizing: border-box;
  }
`

export default WrapperBinder;